exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress-spinner{animation:rotate 1s infinite linear;border:6px solid #e9e9e9;border-left-color:#195aa6;border-radius:50%;box-sizing:border-box;display:inline-block;height:48px;transform:translateZ(0);width:48px}@keyframes rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.progress-spinner-container{align-items:center;display:flex;overflow:hidden}.progress-spinner-container.progress-spinner-column{flex-direction:column}.progress-spinner-container.progress-spinner-column .progress-spinner{margin-bottom:.666em}.progress-spinner-container:not(.progress-spinner-column) .progress-spinner{margin-right:.666em}", ""]);

// exports
